export default {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://pba.pipeflare.io/',
  CHECKOUT_FRAMES_PUBLIC_KEY: 'pk_sbox_36s2rw4mz2x7uttauifnqscgpyi',
};
